import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { NgClass } from '@angular/common'; // Import NgClass
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router'; // Import RouterModule

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, NgClass, RouterModule], // Include CommonModule and NgClass
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  @Output() sidebarToggle = new EventEmitter<boolean>(); // Emit event for sidebar toggle
  sidebarOpen = false; // Controls the state of the sidebar
  userName: string = '';
  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.updateUserName();
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    this.sidebarToggle.emit(this.sidebarOpen); // Emit the event with the current state
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  updateUserName() {
    const token = this.authService.getToken();
    if (token) {
      const decodedToken = this.decodeToken(token);
      this.userName = `${decodedToken.first_name} ${decodedToken.last_name}`;
    }
  }

  private decodeToken(token: string): any {
    const payloadBase64 = token.split('.')[1];
    const payloadJson = decodeURIComponent(atob(payloadBase64).split('').map(c => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(payloadJson);
  }
}
